export enum IndividualGoalStatus {
    Draft = 1,
    CreatedPendingApproval = 2,
    Declined = 3,
    InProgress = 4,
    CompletedPendingApproval = 5,
    ClosedDone = 6,
    Archived = 7
}
